import { AccessEventDoor, DoorType } from 'graphql/generated/graphqlTypes';

export function generateMockAccessEventDoor({
  id = 'mockAccessEventDoorId',
  name = 'mockAccessEventDoorName',
  type = DoorType.Tanlock
}: Partial<Omit<AccessEventDoor, '__typename'>>): AccessEventDoor {
  return {
    __typename: 'AccessEventDoor',
    id,
    name,
    type
  };
}
